import { useEffect, useState } from 'react';
import { useAccount } from '@bnnvara/accounts';
import { track } from '@bnnvara/analytics/src/track';
import { utmParams } from '../../helpers/utmParams';

import { donationParams } from './formParams';
import { useDonationData } from './useDonationData';

export const useDonation = () => {
  const { allAmountOptions, paymentTermOptions, DEFAULT_PERIOD } =
    useDonationData();

  const { profile } = useAccount();
  const {
    firstName: paramsFirstName,
    middleName: paramsMiddleName,
    lastName: paramsLastName,
    email: paramsEmail,
    period: paramsPeriod,
  } = donationParams();

  const [amount, setAmount] = useState(null);
  const [period, setPeriod] = useState(paramsPeriod || DEFAULT_PERIOD);

  const [selectedAmountOptions, setSelectedAmountOptions] = useState(
    allAmountOptions.get(period)
  );

  const handleNumberInput = (event) => {
    const disableChar = event.charCode >= 48 && event.charCode <= 57;

    if (!disableChar) {
      event.preventDefault();
      return false;
    }

    return true;
  };

  const handleOnSubmit = async (params, donateMutation) => {
    track('donatie', 'click', 'doorgaan-naar-betalen');

    const { amount: handlerAmount } = params;
    const euroToCents = handlerAmount * 100;
    // added utm check here as we need to refactor this within the bff that it can handle a null value as empty object.
    let utm = utmParams();
    if (utm === null) {
      utm = {};
    }
    const values = { DonateInput: { ...params, utm, amount: euroToCents } };

    try {
      const result = await donateMutation({
        variables: values,
      });

      if (!result) {
        return {
          error: {
            message: 'Er ging iets mis',
            fields: {},
          },
        };
      }

      return window.location.assign(result.data.donate);
    } catch (error) {
      return {
        error: {
          message: 'Er ging iets mis',
          fields: {},
        },
      };
    }
  };

  const formData = {
    firstName: profile?.firstName || paramsFirstName,
    middleName: profile?.middleName || paramsMiddleName,
    lastName: profile?.lastName || paramsLastName,
    email: profile?.email || paramsEmail,
    period: paramsPeriod,
  };

  /** Change amount options based on period */
  useEffect(
    () => period && setSelectedAmountOptions(allAmountOptions.get(period)),
    [period]
  );

  return {
    handleNumberInput,
    setPeriod,
    handleOnSubmit,
    amount,
    selectedAmountOptions,
    setAmount,
    paymentTermOptions,
    formData,
    period,
  };
};
